class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    // Skip JS binding for no-JS fallback forms (e.g. the secondary vertical-sort
    // facet-filters-form). Without this guard both elements fire renderPage on
    // every sort/filter change, causing a double render.
    if (!facetForm.classList.contains("no-js")) {
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static rebindMobileDrawerEvents() {
    const menuDrawer = document.getElementById("FacetFiltersFormMobile");
    if (!menuDrawer) return;

    const drawer = menuDrawer.closest("menu-drawer");
    if (drawer && typeof drawer.bindEvents === "function") {
      drawer.bindEvents();
    }

    // Also ensure close button has click listener
    const closeButton = document.querySelector(
      ".mobile-facets__close-button, .drawer__close"
    );
    if (closeButton) {
      // Remove any existing listener to avoid duplicates
      const newCloseButton = closeButton.cloneNode(true);
      closeButton.parentNode.replaceChild(newCloseButton, closeButton);

      // Add fresh click listener
      newCloseButton.addEventListener("click", function () {
        const drawer = this.closest("menu-drawer");
        if (drawer && typeof drawer.close === "function") {
          drawer.close();
        }
      });
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (typeof selectMyFilterBrands == "function")
      window.selectMyFilterBrands();
    setTimeout(() => {
      if (typeof selectMyFilterCategory == "function")
        window.selectMyFilterCategory();
      if (typeof selectMyFilterCategoryGender == "function")
        window.selectMyFilterCategoryGender();
      // Trigger the collection reorder scheduler if available
      if (typeof scheduleMoveAfterFilters === "function")
        scheduleMoveAfterFilters();
    }, 200);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);

        if (typeof selectMyFilter == "function") window.selectMyFilter();
        if (typeof selectMyFilterBrands == "function")
          window.selectMyFilterBrands();
        setTimeout(() => {
          if (typeof selectMyFilterCategory == "function")
            window.selectMyFilterCategory();
          if (typeof selectMyFilterCategoryGender == "function")
            window.selectMyFilterCategoryGender();
          // Trigger the collection reorder scheduler if available
          if (typeof scheduleMoveAfterFilters === "function")
            scheduleMoveAfterFilters();
        }, 200);

        if (typeof applyActiveSort == "function") applyActiveSort();

        // Wishlist reload
        if (typeof ReloadSmartWishlist === "function") ReloadSmartWishlist();

        // Reset infinite scroll state after sort/filter
        window.allPagesFetched = false;
        window.isSorting = false;
        if (typeof allPagesFetched !== "undefined") allPagesFetched = false;
        if (typeof isSorting !== "undefined") isSorting = false;

        // Disconnect any existing observers
        if (window.infiniteScrollObserver) {
          try { window.infiniteScrollObserver.disconnect(); } catch (e) { }
          window.infiniteScrollObserver = null;
        }

        // Show pagination
        const pagination = document.querySelector("#product-grid-Pagination");
        if (pagination) pagination.style.display = "";
        const paginationLink = document.querySelector(".infinite_pagination_colleciton");
        if (paginationLink) paginationLink.style.display = "";

        // Remove any leftover loading spinners
        const existingSpinner = document.getElementById("stock-sort-loader");
        if (existingSpinner) existingSpinner.remove();

        // Re-enable infinite scroll
        if (typeof window.toggleInfiniteScroll === "function") {
          try { window.toggleInfiniteScroll(true); } catch (e) { }
        }

        // Update add to cart buttons
        if (typeof updateAddToCartButtons === "function") {
          updateAddToCartButtons();
        }

        // Rebind mobile drawer events
        const isMobileView = window.innerWidth < 768;
        if (isMobileView) {
          FacetFiltersForm.rebindMobileDrawerEvents();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);

    // Reset flags immediately — no artificial delay needed
    window.allPagesFetched = false;
    window.isSorting = false;
    if (typeof allPagesFetched !== "undefined") allPagesFetched = false;
    if (typeof isSorting !== "undefined") isSorting = false;

    // Disconnect any existing observers
    if (window.infiniteScrollObserver) {
      try { window.infiniteScrollObserver.disconnect(); } catch (e) { }
      window.infiniteScrollObserver = null;
    }

    // Rebind mobile drawer events after cache render
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      FacetFiltersForm.rebindMobileDrawerEvents();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount")?.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));

    if (typeof selectMyFilterBrands == "function")
      window.selectMyFilterBrands();
    if (typeof selectMyFilter == "function") window.selectMyFilter();
    setTimeout(() => {
      if (typeof selectMyFilterCategory == "function")
        window.selectMyFilterCategory();
      if (typeof selectMyFilterCategoryGender == "function")
        window.selectMyFilterCategoryGender();
      // Trigger the collection reorder scheduler if available
      if (typeof scheduleMoveAfterFilters === "function")
        scheduleMoveAfterFilters();
    }, 1000);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    const menuDrawer = document.getElementById("FacetFiltersFormMobile");
    if (menuDrawer) {
      const drawer = menuDrawer.closest("menu-drawer");
      if (drawer && typeof drawer.bindEvents === "function") {
        drawer.bindEvents();
      }

      // Ensure drawer can be closed with slight delay
      setTimeout(() => {
        FacetFiltersForm.rebindMobileDrawerEvents();
      }, 100);
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

// Helper function to update add to cart buttons after sorting
function updateAddToCartButtons() {
  const productCards = document.querySelectorAll(".grid__item, .product-card");

  productCards.forEach((card) => {
    const addToCartBtn = card.querySelector(
      '.add-to-cart-btn, button[name="add"], .quick-add__submit'
    );

    if (addToCartBtn) {
      // Use the same stock detection logic from your sorting code
      const isInStock = isProductInStock(card);

      if (!isInStock) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = "Sold Out";
        addToCartBtn.classList.add("disabled", "sold-out");
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "Add to Cart";
        addToCartBtn.classList.remove("disabled", "sold-out");
      }
    }
  });
}

// Use the same stock detection from your sorting code
function isProductInStock(productElement) {
  const inventoryAttr = productElement.getAttribute("data-inventory");
  if (inventoryAttr !== null) {
    const inventory = parseInt(inventoryAttr);
    if (inventory <= 0) return false;
    if (inventory > 0) return true;
  }

  const soldOutSelectors = [
    ".sold-out",
    ".out-of-stock",
    '[class*="sold-out"]',
    '[class*="out-of-stock"]',
    ".product-form__error-message",
    '[data-availability="sold-out"]',
  ];

  for (const sel of soldOutSelectors) {
    if (productElement.querySelector(sel)) return false;
  }

  if (
    productElement.classList.contains("sold-out") ||
    productElement.classList.contains("out-of-stock")
  ) {
    return false;
  }

  const addButton = productElement.querySelector(
    'button[name="add"], .add-to-cart, button[type="submit"], .quick-add__submit'
  );

  if (addButton) {
    const txt = addButton.textContent.trim().toLowerCase();
    if (
      txt.includes("sold out") ||
      txt.includes("out of stock") ||
      txt.includes("unavailable")
    )
      return false;
    if (addButton.disabled) return false;
  }

  try {
    const productData = productElement.querySelector(
      'script[type="application/json"]'
    );
    if (productData) {
      const data = JSON.parse(productData.textContent);
      if (data.available === false) return false;
      if (data.variants && Array.isArray(data.variants)) {
        const allUnavailable = data.variants.every(
          (v) => v.available === false
        );
        if (allUnavailable) return false;
      }
    }
  } catch (e) { }

  const text = productElement.textContent.toLowerCase();
  if (text.includes("sold out") || text.includes("out of stock")) {
    const badges = productElement.querySelectorAll(
      '.badge, .product-badge, [class*="badge"]'
    );
    for (const badge of badges) {
      const badgeText = badge.textContent.toLowerCase();
      if (badgeText.includes("sold out") || badgeText.includes("out of stock"))
        return false;
    }
  }

  return true;
}
